import React from 'react';
import classes from './LocationPage.css';
import Book from '../../components/Book/Book';

const mapSource =
   'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3191.0767901835984!2d174.75803061636483!3d-36.88851118943979!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6d0d4631752c009b%3A0x10a722a5088f2568!2s613+Mount+Eden+Rd%2C+Mount+Eden%2C+Auckland+1024!5e0!3m2!1sen!2snz!4v1533786770026';

const locationpage = (props) => (
   <div className={classes.LocationPage}>
      <iframe className={classes.Map} title="google map" src={mapSource} frameBorder={'0'} style={{ border: 0 }} allowFullScreen />
      <Book />
   </div>
);

export default locationpage;



// WEBPACK FOOTER //
// ./src/containers/LocationPage/LocationPage.js